type TimeUnit = "days" | "hours" | "minutes";

const app_name = "narris";

export const storeInLocal = (
  key: string,
  value: any,
  expiryTime: number,
  unit: TimeUnit
): void => {
  const now = new Date();

  let expiryMilliseconds: number;
  switch (unit) {
    case "days":
      expiryMilliseconds = expiryTime * 24 * 60 * 60 * 1000;
      break;
    case "hours":
      expiryMilliseconds = expiryTime * 60 * 60 * 1000;
      break;
    case "minutes":
      expiryMilliseconds = expiryTime * 60 * 1000;
      break;
    default:
      throw new Error(
        "Invalid time unit. Please use 'days', 'hours', or 'minutes'."
      );
  }

  const expiryDate = now.getTime() + expiryMilliseconds;
  const item = {
    value: value,
    expiry: expiryDate,
  };

  localStorage.setItem(app_name + ":" + key, JSON.stringify(item));
};

export const retrieveFromLocal = <T>(key: string): T | null => {
  const itemStr = localStorage.getItem(app_name + ":" + key);
  if (!itemStr) {
    return null;
  }

  const item = JSON.parse(itemStr);
  const now = new Date();

  if (now.getTime() > item.expiry) {
    localStorage.removeItem(app_name + ":" + key);
    return null;
  }

  return item.value as T;
};

export const removeFromLocal = <T>(key: string): T | null => {
  const itemStr = localStorage.getItem(app_name + ":" + key);
  if (!itemStr) {
    return null;
  }
  localStorage.removeItem(app_name + ":" + key);
  return null;
};
